import { useState, useCallback } from 'react'
import useServiceVariablesResources from '../../shared/resources/api/v1/admin/docker/useServiceVariablesResources'

export default function useServiceVariablesState(teamSlug, projectSlug, serviceSlug) {
  const [variables, setVariables] = useState([])
  const [loading, setLoading] = useState(true)

  const {
    all,
    create,
    update,
    destroy,
  } = useServiceVariablesResources(teamSlug, projectSlug, serviceSlug)

  const load = useCallback(() => {
    return all()
      .then((response) => setVariables(response.serviceVariables || []))
      .catch(() => setVariables([]))
      .finally(() => setLoading(false))
  }, [all])

  const refresh = useCallback(() => {
    return all()
      .then((response) => setVariables(response.serviceVariables || []))
      .catch(() => setVariables([]))
  }, [all])

  const createVariable = useCallback((data) => {
    return create(data).then(() => refresh())
  }, [create, refresh])

  const updateVariable = useCallback((id, data) => {
    return update(id, data).then(() => refresh())
  }, [update, refresh])

  const destroyVariable = useCallback((id) => {
    return destroy(id).then(() => refresh())
  }, [destroy, refresh])

  return {
    variables,
    loading,
    load,
    createVariable,
    updateVariable,
    destroyVariable,
  }
}
